<template>
  <b-container fluid class="px-0">
    <div class="position-relative content-div">
      <LiveQATopOffer :customerInfo="customerInfo"/>
      <LiveQACategoriesCards 
        v-on:navigate="navigate($event)" 
        :customerInfo="customerInfo"/>
      <component
          :is="contentComponent"
          @updated="contentUpdated"
          :customerInfo="customerInfo"
          :liveqaCardsData="liveqaCardsData"
          :step="step"
      />
    </div>
  </b-container>
</template>

<script>
import LiveQATopOffer from "@/components/centre/liveqa/LiveQATopOffer.vue";
import LiveQACategoriesCards from "@/components/centre/liveqa/LiveQACategoriesCards.vue";
import LiveQAShowAllCards from "@/components/centre/liveqa/LiveQAShowAllCards.vue";

import CardImage1Img from "@/assets/images/centre/liveqa/liveqa-cards/CardImage1.png";
import CardImage2Img from "@/assets/images/centre/liveqa/liveqa-cards/CardImage2.png";
import CardImage3Img from "@/assets/images/centre/liveqa/liveqa-cards/CardImage3.png";
import CardImage4Img from "@/assets/images/centre/liveqa/liveqa-cards/CardImage4.png";
import CardImage5Img from "@/assets/images/centre/liveqa/liveqa-cards/CardImage5.png";
import CardImage6Img from "@/assets/images/centre/liveqa/liveqa-cards/CardImage6.png";
import CardImage7Img from "@/assets/images/centre/liveqa/liveqa-cards/CardImage7.png";
import CardImage8Img from "@/assets/images/centre/liveqa/liveqa-cards/CardImage8.png";
import CardImage9Img from "@/assets/images/centre/liveqa/liveqa-cards/CardImage9.png";
import CardImage10Img from "@/assets/images/centre/liveqa/liveqa-cards/CardImage10.png";
import CardImage11Img from "@/assets/images/centre/liveqa/liveqa-cards/CardImage11.png";
import CardImage12Img from "@/assets/images/centre/liveqa/liveqa-cards/CardImage12.png";
import CardImage13Img from "@/assets/images/centre/liveqa/liveqa-cards/CardImage13.png";

export default {
  title: "Dropsmart Center Live Q&A",
  name: "LiveQA",
  props: ["page", "customerInfo", "step"],
  components: {
    LiveQATopOffer,
    LiveQACategoriesCards,
    LiveQAShowAllCards,
  },
  mounted() {
    let target = this.page ? this.page : "LiveQAShowAllCards";
    console.log("navigating to " + target);
    this.navigate(target);
  },
  data() {
    return {
      content: null,
      // categories possible by now: LiveQA
      liveqaAllCardsData: [
        {
          id: 1,
          category: "MasterApp",
          productTitle: "Live Q&A #1",
          description: "How to make the most of Dropsmart filter",
          modalDescription: "How to make the most of Dropsmart filter",
          cardImage: CardImage1Img,
          videoUrl: "https://player.vimeo.com/video/889621765",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },  
        {
          id: 2,
          category: "MasterApp",
          productTitle: "Live Q&A #2",
          description: "Filter through constituents for expert-level precision",
          modalDescription: "Filter through constituents for expert-level precision",
          cardImage: CardImage2Img,
          videoUrl: "https://player.vimeo.com/video/929905288",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 3,
          category: "MasterApp",
          productTitle: "Live Q&A #3",
          description: "Essential oil shelflife & aroma preferences",
          modalDescription: "Essential oil shelflife & aroma preferences",
          cardImage: CardImage3Img,
          videoUrl: "https://player.vimeo.com/video/929905381",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 4,
          category: "MasterApp",
          productTitle: "Live Q&A #4",
          description: "Spot-On Blending with Dropsmart",
          modalDescription: "Spot-On Blending with Dropsmart",
          cardImage: CardImage4Img,
          videoUrl: "https://player.vimeo.com/video/929905449",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 5,
          category: "MasterApp",
          productTitle: "Live Q&A #5",
          description: "Grow your essential oil reputation with clarity, confidence & accuracy",
          modalDescription: "Grow your essential oil reputation with clarity, confidence & accuracy",
          cardImage: CardImage5Img,
          videoUrl: "https://player.vimeo.com/video/929905638",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 6,
          category: "MasterApp",
          productTitle: "Live Q&A #6",
          description: "How to make the most of Dropsmart search",
          modalDescription: "How to make the most of Dropsmart search",
          cardImage: CardImage6Img,
          videoUrl: "https://player.vimeo.com/video/937446029",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 7,
          category: "MasterApp",
          productTitle: "Live Q&A #7",
          description: "Advanced Aromatherapy Methods for 2024",
          modalDescription: "Advanced Aromatherapy Methods for 2024",
          cardImage: CardImage7Img,
          videoUrl: "https://player.vimeo.com/video/953695873",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 8,
          category: "MasterApp",
          productTitle: "Live Q&A #8",
          description: "Better Blends, Structured Success for Students & Educators",
          modalDescription: "Better Blends, Structured Success for Students & Educators",
          cardImage: CardImage8Img,
          videoUrl: "https://player.vimeo.com/video/832652660",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 9,
          category: "MasterApp",
          productTitle: "Live Q&A #9",
          description: "Fast Search, Faster Results",
          modalDescription: "Fast Search, Faster Results",
          cardImage: CardImage9Img,
          videoUrl: "https://player.vimeo.com/video/1013603089",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 10,
          category: "MasterApp",
          productTitle: "Live Q&A #10",
          description: "Efficient and Sustainable Blending with Dropsmart",
          modalDescription: "Efficient and Sustainable Blending with Dropsmart",
          cardImage: CardImage10Img,
          videoUrl: "https://player.vimeo.com/video/1015840748",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 11,
          category: "MasterApp",
          productTitle: "Live Q&A #11",
          description: "Template Based Consultations",
          modalDescription: "Template Based Consultations",
          cardImage: CardImage11Img,
          videoUrl: "https://player.vimeo.com/video/1026660753",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 12,
          category: "MasterApp",
          productTitle: "Live Q&A #12",
          description: "Pre-Built Blending Templates",
          modalDescription: "Pre-Built Blending Templates",
          cardImage: CardImage12Img,
          videoUrl: "https://player.vimeo.com/video/1026662279",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },        
        {
          id: 13,
          category: "MasterApp",
          productTitle: "Live Q&A #13",
          description: "Efficient Tracking of Client Results",
          modalDescription: "Efficient Tracking of Client Results",
          cardImage: CardImage13Img,
          videoUrl: "https://player.vimeo.com/video/1035738152",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },        
      ],
    };
  },
  computed: {
    contentComponent() {
      return this.content;
    },
    liveqaCardsData() {
      return this.liveqaAllCardsData.filter(function(u) {
        return u.showOnDeck;
      });
    },
  },
  methods: {
    navigate(routeName) {
      this.content = routeName;
    },
    contentUpdated() {
      this.customerInfo = JSON.parse(sessionStorage.getItem("customerInfo"));
    },
  },
};
</script>

<style scoped lang="scss">

</style>